const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

document.documentElement.classList.add('yoniq-reveal-ready');

const reveal = (element) => {
  element.classList.add('is-visible');
};

const observer = reduceMotion.matches
  ? null
  : new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const replayOnReentry = entry.target.matches('#pantas-platform');

          if (entry.isIntersecting) {
            reveal(entry.target);
            if (!replayOnReentry) observer.unobserve(entry.target);
          } else if (replayOnReentry) {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -8% 0px',
      }
    );

const initializeRevealElements = (root = document) => {
  root.querySelectorAll('[data-yoniq-reveal]:not([data-yoniq-reveal-ready])').forEach((element) => {
    element.setAttribute('data-yoniq-reveal-ready', '');
    if (reduceMotion.matches || !observer) reveal(element);
    else observer.observe(element);
  });
};

initializeRevealElements();

document.addEventListener('shopify:section:load', (event) => {
  initializeRevealElements(event.target);
});
